import { getRegistrationQuestions, getQuestionVisibilityFilters, getProductQuestions } from 'event-widgets/redux/selectors/appData';
import { getIn } from 'icepick';
import Fields from '@cvent/event-fields/RegistrationOptionFields.json';
import { getFieldIdsFromFilters } from '@cvent/event-core/src/fields/visibilityFields';
export const getQuestionIdsForVisibilityField = (state, fieldId, isGuest, regPathId) => {
    const questionIds = [];
    let questions = getRegistrationQuestions(state);
    const productQuestions = getProductQuestions(state.appData);
    if (productQuestions) {
        questions = Object.assign(Object.assign({}, questions), productQuestions);
    }
    if (!questions) {
        return questionIds;
    }
    Object.keys(questions).filter(questionId => {
        var _a;
        if ((_a = questions[questionId].registrationPathQuestionAssociations) === null || _a === void 0 ? void 0 : _a.includes(regPathId)) {
            const filters = getQuestionVisibilityFilters(state, questionId);
            if (filters && isQuestionAvailableForRegistrant(state, questionId, isGuest, regPathId)) {
                const fieldIds = getFieldIdsFromFilters(filters);
                if (isFieldLinkedToQuestionVisibilityLogic(fieldIds, fieldId)) {
                    questionIds.push(questionId);
                }
            }
        }
    });
    return questionIds;
};
export const getQuestionIdsWithVisibilityLogic = (state, isGuest, regPathId) => {
    let questions = getRegistrationQuestions(state);
    const productQuestions = getProductQuestions(state.appData);
    if (productQuestions) {
        questions = Object.assign(Object.assign({}, questions), productQuestions);
    }
    if (questions) {
        const questionIds = Object.keys(questions);
        return questionIds.filter(questionId => {
            var _a;
            const isOnRegPath = (_a = questions[questionId].registrationPathQuestionAssociations) === null || _a === void 0 ? void 0 : _a.includes(regPathId);
            const filters = getIn(questions[questionId], ['question', 'visibilityLogic', 'filters']);
            return (isOnRegPath &&
                filters &&
                filters.length &&
                isQuestionAvailableForRegistrant(state, questionId, isGuest, regPathId));
        });
    }
    return [];
};
export const getQuestionVisibilityFieldIdsForQuestions = (state, questionIds) => {
    const fieldIds = [];
    questionIds.forEach(questionId => {
        const filters = getQuestionVisibilityFilters(state, questionId);
        if (filters) {
            const idsFromFilters = getFieldIdsFromFilters(filters);
            idsFromFilters.forEach(fieldId => {
                if (!fieldIds.includes(fieldId)) {
                    fieldIds.push(fieldId);
                }
            });
        }
    });
    return fieldIds;
};
export const isQuestionAvailableForRegistrant = (state, questionId, isGuestReg, regPathId) => {
    var _a;
    const regQuestion = getIn(state, ['appData', 'registrationSettings', 'registrationQuestions', questionId]);
    let isAvailable = false;
    if (regQuestion) {
        let audienceType = regQuestion.question.additionalInfo.audienceType;
        if ((_a = regQuestion === null || regQuestion === void 0 ? void 0 : regQuestion.audienceTypePerRegistrationPathId) === null || _a === void 0 ? void 0 : _a[regPathId]) {
            audienceType = regQuestion.audienceTypePerRegistrationPathId[regPathId].audienceType;
        }
        if (!isGuestReg && audienceType && audienceType !== 'GuestOnly') {
            isAvailable = true;
        }
        if (isGuestReg && audienceType && audienceType !== 'InviteeOnly') {
            isAvailable = true;
        }
    }
    else {
        const productQuestion = getIn(state, ['appData', 'registrationSettings', 'productQuestions', questionId]);
        if (productQuestion && !isGuestReg) {
            isAvailable = true;
        }
    }
    return isAvailable;
};
/**
 * Checks to see if field is included in question visibility filters. Special handling for address country and state
 * fields as these are controlled by the associated code widget so we use it instead
 */
export const isFieldLinkedToQuestionVisibilityLogic = (fieldIds, fieldId) => {
    return (fieldIds.includes(fieldId) ||
        (fieldId === Fields.workCountryCode.id && fieldIds.includes(Fields.workCountry.id)) ||
        (fieldId === Fields.homeCountryCode.id && fieldIds.includes(Fields.homeCountry.id)) ||
        (fieldId === Fields.workStateCode.id && fieldIds.includes(Fields.workState.id)) ||
        (fieldId === Fields.homeStateCode.id && fieldIds.includes(Fields.homeState.id)));
};
